import React from 'react';
import { connect } from 'react-redux';
import { DBTextAreaObjective } from '_components';
import styles from './Common.module.css'

class StrComments extends React.Component {

    render() {
        return (
            <div className={styles.textarea_row}>
                <span className={styles.flag} />
                <label className={styles.textarea_label}>Comments</label>
                <DBTextAreaObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVESTR'
                    entityKeyColumn='STNO'
                    entityKeyValue={this.props.stno}
                    field='STCOMMENTS'
                    className={styles.textarea}
                />
                <span className={styles.prev_comments_wrapper}>
                    {this.props.prevComments}
                </span>
            </div>
        );
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let stno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESTR)
        .find(key => (state.entities.notes.PTOBJECTIVESTR[key].STEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESTR[key].STNTNO === pk && noteType !== 1)));

    let prevComments = '';

    if (noteType !== 1 && state.entities.notes.PTOBJECTIVESTRPREV[pk]) {
        prevComments = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STCOMMENT'];
    }


    return {
        noteId,
        stno,
        prevComments,
    };
}

const connectedStrComments = connect(mapStateToProps)(StrComments);
export { connectedStrComments as StrComments };


